module.exports = __webpack_public_path__ + "static/media/background-be-worker.cc6bdf9b.jpg";